import { directoryTypes } from './directoryTypes';

export function getFoldersEndpointByType({ directoryType }) {
	switch (directoryType) {
	case directoryTypes.formula:
		return 'formula';
	case directoryTypes.dataSource:
		return 'datasource';
	case directoryTypes.oneOnOneTemplate:
		return 'oneononetemplate';
	case directoryTypes.report:
		return 'report';
	default:
		throw new Error('Unsupported directory type');
	}
}

export function getItemsEndpointByType({ directoryType }) {
	switch (directoryType) {
	case directoryTypes.formula:
		return 'formulas';
	case directoryTypes.dataSource:
		return 'datasources';
	case directoryTypes.oneOnOneTemplate:
		return 'one-on-one-templates';
	case directoryTypes.report:
		return 'reports';
	case directoryTypes.employee:
	case directoryTypes.employeeInactive:
	case directoryTypes.employeePending:
	case directoryTypes.employeeTracked:
		return 'members';
	case directoryTypes.slideshow:
		return 'slideshows';
	case directoryTypes.tv:
		return 'tvs';
	case directoryTypes.reportPinned:
	case directoryTypes.reportScheduled:
	case directoryTypes.reportDisabled:
		return 'reports';
	case directoryTypes.achievement:
		return 'achievement-types';
	case directoryTypes.contest:
		return 'contests';
	case directoryTypes.contestFinished:
		return 'contest-results';
	default:
		throw new Error('Unsupported directory type');
	}
}

export function getSearchEndpointByType(directoryId) {
	const { directoryType } = directoryId;
	switch (directoryType) {
	case directoryTypes.formula:
	case directoryTypes.dataSource:
	case directoryTypes.oneOnOneTemplate:
	case directoryTypes.report:
		return `folders/${getFoldersEndpointByType(directoryId)}/search`;
	case directoryTypes.employee:
	case directoryTypes.employeeInactive:
	case directoryTypes.employeePending:
	case directoryTypes.employeeTracked:
		return 'members';
	case directoryTypes.slideshow:
	case directoryTypes.tv:
	case directoryTypes.reportPinned:
	case directoryTypes.reportScheduled:
	case directoryTypes.reportDisabled:
	case directoryTypes.achievement:
	case directoryTypes.contest:
	case directoryTypes.contestFinished:
		// folderless types search their own list endpoint with ?q=
		return getItemsEndpointByType(directoryId);
	default:
		throw new Error('Unsupported directory type');
	}
}
